import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class DateValidator {

  static readonly FORMAT_DATE = 'YYYY-MM-DD';

  /**
   * @param date the minimum date to check on
   * @param respectTimestamp handles if the given dates should be checked with the current timestamp or with 00:00:00
   */
  static minDate(date: Date | string, respectTimestamp = false): ValidatorFn {
    return (control: AbstractControl<string | null | Date>): ValidationErrors | null => {
      const raw: any = control.value;
      if (raw == null) {
        return null;
      }

      const controlDate =
        raw instanceof Date
          ? new Date(raw.getTime())
          : new Date(String(raw));

      const validationDate =
        date instanceof Date
          ? new Date(date.getTime())
          : new Date(String(date));

      if (!respectTimestamp) {
        controlDate.setUTCHours(0, 0, 0, 0);
        validationDate.setUTCHours(0, 0, 0, 0);
      }

      return controlDate >= validationDate
        ? null
        : {
          dateMinimum: {
            dateMinimum: validationDate.toISOString(),
            actual: controlDate.toISOString()
          }
        };
    };
  }

  /**
   * @param date the maximum date to check on
   * @param respectTimestamp handles if the given dates should be checked with the current timestamp or with 00:00:00
   */
  static maxDate(date: Date | string, respectTimestamp = false): ValidatorFn {
    return (control: AbstractControl<Date | string | null>): ValidationErrors | null => {
      const raw = control.value;
      if (raw == null) {
        return null;
      }

      const controlDate =
        raw instanceof Date
          ? new Date(raw.getTime())
          : new Date(String(raw));

      const validationDate =
        date instanceof Date
          ? new Date(date.getTime())
          : new Date(String(date));

      if (!respectTimestamp) {
        controlDate.setUTCHours(0, 0, 0, 0);
        validationDate.setUTCHours(0, 0, 0, 0);
      }

      return controlDate <= validationDate
        ? null
        : {
          dateMaximum: {
            dateMaximum: validationDate.toISOString(),
            actual: controlDate.toISOString()
          }
        };
    };
  }
}
